// The duration checkbox group reports an array of keys; the API and the
// exercise tables expect { [minutes]: true }.
export default function normalizeDurationOptions(durationOptions) {
  if (!Array.isArray(durationOptions)) return durationOptions || {};
  return Object.fromEntries(durationOptions.map((minutes) => [String(minutes), true]));
}
